import http from './http';

export default {
    types() {
        return http.get('/notificationtypes');
    },
    targets() {
        return http.get('/notificationtypes/notificationtargets');
    },
    pushNotification(listTypeId, data) {
        return http.post(`/notifications/${listTypeId}/push`, data);
    },
    whitelist() {
        return http.get('/notifications/whitelist');
    },
    saveWhitelist(data) {
        return http.put('/notifications/whitelist', data);
    },
    list() {
        return http.get('/notifications');
    },
};
